import facepaint from 'facepaint'

export default facepaint([
  '@media(min-width: 420px)',
  '@media(min-width: 768px)',
  '@media(min-width: 1280px)',
  '@media(min-width: 1366px)',
])

export const cartMQ = facepaint([
  '@media(min-width: 420px)',
  '@media(min-width: 900px)',
  '@media(min-width: 1280px)',
  '@media(min-width: 1366px)',
])
